import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCheckmark2Medium"><Path d="M18.4403 6.50117C18.7159 6.19215 19.1898 6.16516 19.4989 6.44062C19.808 6.71619 19.8349 7.19003 19.5595 7.49921L9.75968 18.4992C9.62316 18.6523 9.42957 18.7434 9.22452 18.7502C9.01963 18.7569 8.82103 18.6789 8.67472 18.5353L4.47452 14.4103C4.17904 14.1201 4.17462 13.6453 4.46476 13.3498C4.75497 13.0543 5.22978 13.0499 5.5253 13.34L9.163 16.9123L18.4403 6.50117Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2Medium;
